//bao migrate skip
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
class CreateBypassDialog {
    Dialog: BaoDialog = new BaoDialog(Bao.Session.ApplicationName);
    DialogResult: KnockoutObservable<boolean> = this.Dialog.DialogResult;
    Bao = Bao;
    FolderStructureChecklistId = ko.observable('');
    FolderStructures = ko.observableArray([]);
    Checklists = ko.observableArray([]);
    ReportId = ko.observable();
    ShiftbookId = ko.observable();
    ShiftbookTabId = ko.observable();
    SelectedItem = ko.observable(null);
    selectChecklistTemplateMessage = Bao.Session.GetMessage("msgSelectChecklistTemplateMessage");
    //TODO custom filter (filtering by category id) instead own implementation of checklist searcher
    constructor(params: any) {
        this.ReportId(params.ReportId);
        this.ShiftbookId(params.ShiftbookId);
        this.ShiftbookTabId(params.ShiftbookTabId);
        this.Dialog = params.Dialog;
        this.Dialog.Width("750px");
        this.Dialog.Buttons([
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgOk"), $.proxy(this.OkClick, this)),
            new BaoDialog.ButtonFactory(this.Dialog, Bao.Session.GetMessage("msgCancel"), $.proxy(this.CancelClick, this))
        ]);
    }
    init() {
        return Bao.post("BypassTab/GetChecklistsByShiftbookIdWithShiftbookTab", JSON.stringify({
            shiftbookId: this.ShiftbookId(),
            shiftbookTabId: this.ShiftbookTabId()
        }), (result) => {
            this.Checklists([]);
            if (Array.isArray(result)) {
                result.splice(0, 1);
                // if there is only 1 template to choose from, immediately destroy the dialog and set the FolderStructureChecklistId
                if (result.length == 1 && result[0].Checklists.length === 1) {
                    this.FolderStructureChecklistId(result[0].Checklists[0].FolderStructureChecklistId);
                    this.CreateEvaluation(this.FolderStructureChecklistId(), this.ReportId());
                    this.DialogResult(true);
                    this.Dialog.Destroy();
                    this.Dialog.Hide();
                }
                else {
                    this.FolderStructures(result);
                    this.FolderStructures().forEach((item: any) => item.isOpen = ko.observable(false));
                }
            }
        });
    };
    CancelClick(): void {
        this.DialogResult(false);
        this.Dialog.Close();
    }
    OkClick(): void {
        if (this.ValidateDialog()) {
            this.CreateEvaluation(this.FolderStructureChecklistId(), this.ReportId());
            this.DialogResult(true);
            this.Dialog.Close();
        }
    }
    ValidateDialog() {
        var isComplete = true;
        const folderStructureChecklistId = this.FolderStructureChecklistId();
        if (!folderStructureChecklistId
            || folderStructureChecklistId === "00000000-0000-0000-0000-000000000000") {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialog(Bao.Session.ApplicationName, this.selectChecklistTemplateMessage, "info");
        }
        return isComplete;
    }
    ;
    CreateEvaluation(folderStructureChecklistId, reportId) {
        this.Dialog.IsLoading(true);
        return Bao.post('BypassTab/CreateEvaluationByReportShiftbook', JSON.stringify({
            folderStructureChecklistId: folderStructureChecklistId,
            reportId: reportId,
            shiftbookId: this.ShiftbookId()
        }), (result) => {
            if (result != false) {
                baoRouter.setHash("checkware/evaluation/" + result);
            }
            this.Dialog.IsLoading(false);
        });
    }
    ;
    SelectItem(item: any) {
        this.FolderStructureChecklistId(item.FolderStructureChecklistId);
        this.SelectedItem(item);
    }
    ToggleOpen(item) {
        if (item && item.isOpen) {
            item.isOpen(!item.isOpen());
        }
    }
}
export default CreateBypassDialog;